import { makeStyles } from '@material-ui/core'

// Updated styles with new empty state classes
export const useStyles = makeStyles((theme) => ({
  cardViewModeContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },

  lodingMoreButton: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    backgroundColor: 'transparent',
    width: 118,
    height: 40,
    borderWidth: 1,
    borderRadius: 6,
    borderColor: theme.palette.primary.main,
    fontWeight: 700,
    color: theme.palette.primary.main,

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  errorState: {
    position: 'unset'
  },

  buttonWrapper: {
    width: 'max-content',
    display: 'flex',
    padding: '8px 16px 8px 12px',
    gap: '8px',
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  buttonOutlined: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  },

  loadMoreContainer: {
    padding: '45px 0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },

  loadingContainer: {
    marginRight: 5,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
  },

  notFoundItemsMsg: {
    color: theme.palette.primary.main
  },

  loading: {
    width: 20,
    height: 20
  },

  emptyStateContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 250,
    padding: '48px 24px',
    textAlign: 'center',
    background: 'linear-gradient(135deg, rgba(120, 74, 66, 0.02) 0%, rgba(120, 74, 66, 0.05) 100%)',
    borderRadius: '12px',
    margin: '16px',

    [theme.breakpoints.down('sm')]: {
      padding: '32px 20px',
      minHeight: 200,
      margin: '12px'
    }
  },

  emptyStateIcon: {
    marginBottom: 24,
    color: theme.palette.primary.main,
    opacity: 0.7,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.3s ease',

    '&:hover': {
      transform: 'scale(1.05)',
      opacity: 0.9
    },

    '& svg': {
      filter: 'drop-shadow(0 2px 8px rgba(120, 74, 66, 0.1))'
    }
  },

  emptyStateContent: {
    maxWidth: 320
  },

  emptyStateTitle: {
    fontSize: 20,
    fontWeight: 600,
    color: theme.palette.primary.main,
    margin: '0 0 12px 0',
    letterSpacing: '-0.02em',

    [theme.breakpoints.down('sm')]: {
      fontSize: theme.app.typography.h3.fontSize
    }
  },

  emptyStateDescription: {
    fontSize: 15,
    fontWeight: 400,
    color: theme.palette.primary.main,
    margin: '0 0 8px 0',
    lineHeight: 1.6,
    opacity: 0.9,

    [theme.breakpoints.down('sm')]: {
      fontSize: theme.app.typography.label.fontSize
    }
  },

  emptyStateSuggestion: {
    fontSize: theme.app.typography.label.fontSize,
    fontWeight: 400,
    color: theme.palette.primary.main,
    margin: 0,
    lineHeight: 1.5,
    opacity: 0.8,
    fontStyle: 'italic',

    [theme.breakpoints.down('sm')]: {
      fontSize: 13
    }
  },

  totalItemsContainer: {
    '& p': {
      color: theme.palette.primary.main
    }
  }
}))
